import { render, staticRenderFns } from "./InternetAndMobileOnBoarding.vue?vue&type=template&id=521b782e&scoped=true&"
import script from "./InternetAndMobileOnBoarding.vue?vue&type=script&lang=js&"
export * from "./InternetAndMobileOnBoarding.vue?vue&type=script&lang=js&"
import style0 from "./InternetAndMobileOnBoarding.vue?vue&type=style&index=0&id=521b782e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521b782e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('521b782e')) {
      api.createRecord('521b782e', component.options)
    } else {
      api.reload('521b782e', component.options)
    }
    module.hot.accept("./InternetAndMobileOnBoarding.vue?vue&type=template&id=521b782e&scoped=true&", function () {
      api.rerender('521b782e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/orange/broadband/demands/showcase/internetandmobileoffers/components/InternetAndMobileOnBoarding.vue"
export default component.exports